var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiInsightsIcon = function SvgAiInsightsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.493 2.551a.375.375 0 0 0-.736 0l-.08.405a1.875 1.875 0 0 1-1.471 1.47l-.405.081a.375.375 0 0 0 0 .736l.405.08a1.875 1.875 0 0 1 1.47 1.471l.081.405a.375.375 0 0 0 .736 0l.08-.405a1.875 1.875 0 0 1 1.471-1.47l.405-.081a.375.375 0 0 0 0-.736l-.405-.08a1.875 1.875 0 0 1-1.47-1.471l-.081-.405Z",
    fill: "#000624"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.493 2.551a.375.375 0 0 0-.736 0l-.08.405a1.875 1.875 0 0 1-1.471 1.47l-.405.081a.375.375 0 0 0 0 .736l.405.08a1.875 1.875 0 0 1 1.47 1.471l.081.405a.375.375 0 0 0 .736 0l.08-.405a1.875 1.875 0 0 1 1.471-1.47l.405-.081a.375.375 0 0 0 0-.736l-.405-.08a1.875 1.875 0 0 1-1.47-1.471l-.081-.405Z",
    fill: "url(#aiInsightsIcon_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.237 4.776a.375.375 0 0 0-.724 0l-.335 1.231a4.875 4.875 0 0 1-3.421 3.42l-1.23.336a.375.375 0 0 0 0 .724l1.23.335a4.875 4.875 0 0 1 3.42 3.42l.336 1.232a.375.375 0 0 0 .724 0l.335-1.231a4.875 4.875 0 0 1 3.42-3.42l1.232-.336a.375.375 0 0 0 0-.724l-1.231-.335a4.875 4.875 0 0 1-3.42-3.421l-.336-1.23Z",
    fill: "#000624"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.237 4.776a.375.375 0 0 0-.724 0l-.335 1.231a4.875 4.875 0 0 1-3.421 3.42l-1.23.336a.375.375 0 0 0 0 .724l1.23.335a4.875 4.875 0 0 1 3.42 3.42l.336 1.232a.375.375 0 0 0 .724 0l.335-1.231a4.875 4.875 0 0 1 3.42-3.42l1.232-.336a.375.375 0 0 0 0-.724l-1.231-.335a4.875 4.875 0 0 1-3.42-3.421l-.336-1.23Z",
    fill: "url(#aiInsightsIcon_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aiInsightsIcon_svg__a",
    x1: 2.25,
    y1: 9,
    x2: 15.75,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAEBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#7B91FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D33DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aiInsightsIcon_svg__b",
    x1: 2.25,
    y1: 9,
    x2: 15.75,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAEBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#7B91FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D33DE"
  })))));
};
export default SvgAiInsightsIcon;